"use client";
import { j as i } from "./jsx-runtime-CJ-St4mQ.mjs";
import { forwardRef as p } from "react";
import { t as u } from "./tv.config-BuYIgndg.mjs";
import { u as v } from "./useRender-DCcXqLqs.mjs";
import { m as c } from "./useRenderElement-B8V3_e8R.mjs";
const f = u({
  base: ["Paper_Root", "bg-white", "rounded-xl", "overflow-hidden", "block"],
  variants: {
    variant: {
      elevation: ["shadow-md"],
      outlined: ["border", "border-gray-300", "shadow-none"]
    },
    square: {
      true: "rounded-none"
    },
    elevation: {
      sm: "shadow-sm",
      md: "shadow-md",
      lg: "shadow-lg",
      xl: "shadow-xl",
      none: "shadow-none"
    }
  },
  defaultVariants: {
    variant: "elevation",
    elevation: "md"
  }
}), w = p((o, r) => {
  const {
    render: a,
    className: n,
    square: s,
    variant: e = "elevation",
    elevation: t = "md",
    ...d
  } = o, l = a ?? /* @__PURE__ */ i.jsx("div", {}), m = {
    ref: r,
    className: f({
      square: s,
      variant: e,
      elevation: e === "outlined" ? "none" : t,
      class: n
    })
  };
  return v({
    render: l,
    props: c(m, d)
  });
});
w.displayName = "Paper";
export {
  w as default
};
